import React from 'react';
import { Switch, Route, RouteComponentProps, Redirect } from 'react-router-dom';
import ITradeUP from './modules/ITradeUP';
import Upfintech from './modules/Upfintech';
import HUHOO from './modules/HUHOO';
import LAOHU from './modules/LAOHU';
import TradeUP from './modules/TradeUP';
import AbountUS from './modules/AboutUS';
import UpfintechTiger from './modules/UpfintechTiger';
import AboutHUHOO from './modules/AboutHUHOO';
import TIGERSHARES from './modules/TIGERSHARES';

import './style.scss';

const Brand: React.FC<RouteComponentProps> = props => {
    const { path } = props.match;

    return (
        <div className="brand-root">
            <Switch>
                <Route path={`${path}/itradeup`} component={ITradeUP} />
                <Route path={`${path}/UPFINTECH`} component={Upfintech} />
                <Route path={`${path}/HUHOO`} component={HUHOO} />
                <Route path={`${path}/LAOHU`} component={LAOHU} />
                <Route path={`${path}/TRADEUP`} component={TradeUP} />
                <Route path={`${path}/AboutUS`} component={AbountUS} />
                <Route path={`${path}/UPFintechTiger`} component={UpfintechTiger} />
                <Route path={`${path}/AboutHUHOO`} component={AboutHUHOO} />
                <Route path={`${path}/TIGERSHARES`} component={TIGERSHARES} />
                <Redirect to={{ ...props.location, pathname: `${path}/itradeup` }} />
            </Switch>
        </div>
    );
};

export default Brand;
